import React from "react";
import Main from "./Main";
import About from "./About";
import "bootstrap/dist/css/bootstrap.min.css";

const App = () => {
  return (
    <div>
      <Main />
      <About />
    </div>
  );
};

export default App;
